<!-- =========================================================================================
    File Name: CollapseAccordion.vue
    Description: Collapse with accrodion
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vx-card title="Segurança & Plano" code-toggler>

        <p>Vamos alterar a sua senha? <code>Todas as alterações, será necessário confirmar via email.</code></p>

        <div class="mt-5">

            <vs-collapse accordion>



                <vs-collapse-item>

                    <div slot="header">Alterar Senha</div>

                    <div class="vx-row mb-12">
					  <div class="vx-col w-full">
						<vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label="Senha Atual" v-model=senha_atual />
					  </div>
					</div>
					<div class="vx-row mb-12">
					  <div class="vx-col w-full">
						<vs-input type="email" class="w-full" icon-pack="feather" icon="icon-lock" icon-no-border label="Nova Senha" v-model="nova_senha" />
					  </div>
					</div>
					<div class="vx-row mb-12">
					  <div class="vx-col w-full">
						<vs-input class="w-full" icon-pack="feather" icon="icon-lock" icon-no-border label="Confirmar Nova Senha" v-model="c_nova_senha" />
					  </div>
					</div>
					<div class="vx-row">
					  <div class="vx-col w-full">
						<vs-button class="mr-3 mb-2" @click="saveData">Salvar</vs-button>
					  </div>
				</div>
                </vs-collapse-item>



				<vs-collapse-item>

                    <div slot="header">URL Retorno</div>

                    <div class="vx-row mb-12">
					  <div class="vx-col w-full">
						<vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label="URL Retorno (API)" v-model=dadosx.url_retorno />
					  </div>
					</div>
					<div class="vx-row mb-12">
					  <div class="vx-col w-full">
						<vs-input class="w-full" icon-pack="feather" icon="icon-lock" icon-no-border label="PIN" v-model="pin_url" />
					  </div>
					</div>
					<div class="vx-row">
					  <div class="vx-col w-full">
						<vs-button class="mr-3 mb-2" @click="saveDataUrl">Salvar</vs-button>
					  </div>
				</div>
                </vs-collapse-item>

            </vs-collapse>

        </div>


    </vx-card>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from '../../../ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'

export default{
	created() {
		const thisIns = this;
		fetch(this.$store.state.API_URL + 'Info/Home', {
			method: 'POST',
			headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
			body: "token="+localStorage.getItem("token")
		})
		.then((response) => response.text())
		.then((responseData) => {

			var dados = JSON.parse(responseData);
			thisIns.dadosx = dados.meus_dados;
		});
	},
    data() {
        return {
			senha_atual: '',
			nova_senha: '',
			c_nova_senha: '',
			pin_senha: '',
			pin_url: '',
			dadosx: [],
            analyticsData: analyticsData,
            chatMsgInput: '',
            contentImg1: 'content-img-1.jpg',
            profileUser1: 'avatar-s-18.png',
            profileUser2: 'avatar-s-1.png',
            profileUser3: 'avatar-s-12.png',
            overlayImg2: 'card-image-5.jpg',
            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            chatMsg: [
                { senderImg: 'avatar-s-2.png', msg: 'Cake sesame snaps cupcake gingerbread', isSent: true },
                { senderImg: 'avatar-s-5.png', msg: 'Apple pie pie jujubes chupa chups muffin', isSent: false },
                { senderImg: 'avatar-s-2.png', msg: 'Chocolate cake', isSent: true },
                { senderImg: 'avatar-s-5.png', msg: 'Donut sweet pie oat cake dragée fruitcake', isSent: false },
                { senderImg: 'avatar-s-2.png', msg: 'Liquorice chocolate bar jelly beans icing', isSent: true },
                { senderImg: 'avatar-s-5.png', msg: 'Powder toffee tootsie roll macaroon cupcake.', isSent: false },
                { senderImg: 'avatar-s-2.png', msg: 'Apple pie oat cake brownie cotton candy cupcake chocolate bar dessert.', isSent: true },
                { senderImg: 'avatar-s-5.png', msg: 'Biscuit cake jujubes carrot cake topping sweet cake.', isSent: false },
            ]
        }
    },
    components: {
        VueApexCharts,
        StatisticsCardLine,
        VuePerfectScrollbar,
        ChangeTimeDurationDropdown
    },
	methods: {
		saveData()
		{
			this.$vs.loading({
				type:'radius',
			})

			fetch(this.$store.state.API_URL + 'Info/Save/Password', {
				method: 'POST',
				headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
				body: "token="+localStorage.getItem("token")+"&senha_atual="+this.senha_atual+"&nova_senha="+this.nova_senha+"&pin="+this.pin_senha
			})
			.then((response) => response.text())
			.then((responseData) => {
				var dados = JSON.parse(responseData);
				//this.dadosx = dados.dados;
				if(dados.done == true)
				{
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'success'
						});
					}, 4000);

				}
				else
				{
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});

					}, 4000);
				}

			});
		},
		saveDataUrl()
		{
			this.$vs.loading({
				type:'radius',
			})

			fetch(this.$store.state.API_URL + 'Info/Save/URL', {
				method: 'POST',
				headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
				body: "token="+localStorage.getItem("token")+"&url="+this.dadosx.url_retorno+"&pin="+this.pin_url
			})
			.then((response) => response.text())
			.then((responseData) => {
				var dados = JSON.parse(responseData);
				//this.dadosx = dados.dados;
				if(dados.done == true)
				{
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'success'
						});
					}, 4000);

				}
				else
				{
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});

					}, 4000);
				}

			});
		},
		newPin()
		{
			this.$vs.loading({
				type:'radius',
			})

			fetch(this.$store.state.API_URL + 'Info/New/PIN', {
				method: 'POST',
				headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
				body: "token="+localStorage.getItem("token")
			})
			.then((response) => response.text())
			.then((responseData) => {
				var dados = JSON.parse(responseData);
				this.dadosx = dados.dados;
				if(dados.done == true)
				{
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'success'
						});
					}, 4000);

				}
				else
				{
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});

					}, 4000);
				}

			});
		},


        select: function(event) {
			this.$vs.loading({
				type:'radius',
			})
			setTimeout( ()=> {
				this.$vs.loading.close();
				//POST CHANGE PLAN
			}, 10000);
            var targetId = event.currentTarget.id;
            console.log(targetId); // returns 'foo'
        }
    }
}
</script>
